import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { useMedia } from "react-use";
import { Theme } from "@silvertours/front-shared";
import { Button, Heading } from "../../../element";
import { ArrowLink } from "./ArrowLink";
import { List, ListItem, Wrapper } from "./PlainLinkList.styles";
var MAX_LINKS_MOBILE = 10;
var MAX_LINKS_DESKTOP = 15;
export var PlainLinkList = function(param) {
    var _content = param.content, heading = _content.heading, links = _content.links, translations = param.translations;
    var ref = translations || {}, _showAllLabel = ref.showAllLabel, showAllLabel = _showAllLabel === void 0 ? "" : _showAllLabel, _showLessLabel = ref.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "" : _showLessLabel;
    var ref1 = useState(MAX_LINKS_MOBILE), maxVisibleLinks = ref1[0], setMaxVisibleLinks = ref1[1];
    var hasHiddenLinks = links.length > maxVisibleLinks;
    var ref2 = useState(false), linksAreExpanded = ref2[0], setLinksExpanded = ref2[1];
    var wideViewPort = useMedia("(min-width:".concat(Theme.getBreakpoint("lg"), "px)"), false);
    useEffect(function() {
        var maxLinks = wideViewPort ? MAX_LINKS_DESKTOP : MAX_LINKS_MOBILE;
        setMaxVisibleLinks(maxLinks);
    }, [
        wideViewPort,
        links
    ]);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                content: heading,
                rules: {
                    verticalSpacing: {
                        spacingDirection: "neither"
                    }
                }
            }),
            /*#__PURE__*/ _jsx(List, {
                length: links.length,
                children: links.map(function(link, index) {
                    return /*#__PURE__*/ _jsx(ListItem, {
                        linksAreExpanded: linksAreExpanded,
                        maxVisibleLinks: maxVisibleLinks,
                        index: index,
                        children: /*#__PURE__*/ _jsx(ArrowLink, {
                            link: link
                        })
                    }, link.href + link.label);
                })
            }),
            hasHiddenLinks && /*#__PURE__*/ _jsx(Button, {
                content: {
                    label: linksAreExpanded ? showLessLabel : showAllLabel
                },
                onClick: function() {
                    return setLinksExpanded(!linksAreExpanded);
                },
                rules: {
                    variant: "secondary",
                    expanded: true,
                    horizontalSpacing: {
                        isCentered: true
                    },
                    verticalSpacing: {
                        spacingDirection: "neither"
                    }
                }
            })
        ]
    });
};
